import "./ui/prototype.css";
import "./ui/app-extra.css";
import "./ui/figma-v2.css";
import "./ui/layouts.css";
import { cloudConfig } from "./cloud/config";
import { LibraryStore } from "./data/store";
import { LocalStorageRepository } from "./storage/local-storage";
import { bootCloud } from "./ui/account";
import { bindEvents, render } from "./ui/app";
import { ctx } from "./ui/context";
import { refreshSafety } from "./ui/import-export";

async function boot() {
  bindEvents();
  const cfg = cloudConfig();
  // with Supabase configured: account required, data in the cloud. Without: Queue 2 behaviour, data in this browser.
  if (cfg) { await bootCloud(cfg); return; }
  // review preview: Login V2 in front of local mode, with a stand-in for the email code (never in a normal build)
  if (import.meta.env.VITE_PREVIEW_LOGIN === "1") {
    const { bootPreviewLogin } = await import("./preview/demo-login");
    bootPreviewLogin(startLocal);
    return;
  }
  await startLocal();
}
async function startLocal() {
  ctx.store = new LibraryStore(new LocalStorageRepository());
  await ctx.store.init();
  await refreshSafety();
  ctx.V.view = ctx.store.started ? "home" : "welcome";
  render(); scrollTo(0, 0);
}
void boot();
